// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_@rspack+core@1.3.10_@swc+helpers@0.5.13__webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_@rspack+core@1.3.10_@swc+helpers@0.5.13__webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-new-tab a svg {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Link/LinkNewTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".link-new-tab a svg {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
